import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStore } from '../store/auth.store';
import { MatSnackBar } from '@angular/material/snack-bar';

/**
 * Guard que protege las rutas de transferencias internas
 * Bloquea el acceso si la configuración allow_internal_transfers está deshabilitada
 */
export const internalTransfersEnabledGuard: CanActivateFn = (route, state) => {
  const authStore = inject(AuthStore);
  const router = inject(Router);
  const snackBar = inject(MatSnackBar);

  const appConfig = authStore.appConfig();
  const allowInternalTransfers = appConfig?.allow_internal_transfers ?? true;

  // Verificar si las transferencias internas están habilitadas
  if (!allowInternalTransfers) {
    // Mostrar mensaje de error
    snackBar.open(
      'Las transferencias internas están deshabilitadas por el momento.',
      'Entendido',
      {
        duration: 5000,
        panelClass: ['mat-snack-error'],
        horizontalPosition: 'center',
        verticalPosition: 'top'
      }
    );

    // Redirigir al dashboard
    router.navigate(['/']);
    return false;
  }

  return true;
};
